module.exports = __webpack_public_path__ + "static/FaroWeb-RegularLucky-6aaca1771a8510498a06b371cb1f6af5.woff2";